import { Box, Drawer, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const DrawerForm = ({
  open,
  onClose,
  title,
  sidebar,
  children,
  footer,
  width = { xs: '100vw', md: 'min(944px, calc(100vw - 40px))' },
  sidebarWidth = 220,
  bodySx = {},
  contentSx = {},
}) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        width,
        maxWidth: '100vw',
        height: '100dvh',
        display: 'flex',
        backgroundColor: 'background.formTables',
      },
    }}
  >
    <Box
      sx={{
        px: { xs: 2, md: 3 },
        py: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        borderBottom: '1px solid',
        borderColor: 'primary.main',
        backgroundColor: 'background.paper',
        flexShrink: 0,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: 'primary.main',
          fontWeight: 800,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        title={typeof title === 'string' ? title : undefined}
      >
        {title}
      </Typography>
      <IconButton onClick={onClose} size="small" color="primary" aria-label="Cerrar">
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>

    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: sidebar ? `${sidebarWidth}px minmax(0, 1fr)` : '1fr' },
        gridTemplateRows: { xs: sidebar ? 'auto minmax(0, 1fr)' : 'minmax(0, 1fr)', md: 'minmax(0, 1fr)' },
        overflow: 'hidden',
        ...bodySx,
      }}
    >
      {sidebar}
      <Box
        sx={{
          minWidth: 0,
          minHeight: 0,
          overflowY: 'auto',
          py: { xs: 1.25, md: 1.5 },
          backgroundColor: 'background.formTables',
          ...contentSx,
        }}
      >
        {children}
      </Box>
    </Box>

    {footer && (
      <Box sx={{ flexShrink: 0 }}>
        {footer}
      </Box>
    )}
  </Drawer>
);

export default DrawerForm;
